//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

export const INSTAGRAM_USER_STATS_ACTIONS = {
  REQUEST_SUMMARY_INSTAGRAM_USER_STATS: 'REQUEST_SUMMARY_INSTAGRAM_USER_STATS',
  RECEIVE_SUMMARY_INSTAGRAM_USER_STATS: 'RECEIVE_SUMMARY_INSTAGRAM_USER_STATS',
  REQUEST_HMS_AUDIENCE_INSIGHTS_START: 'REQUEST_HMS_AUDIENCE_METRICS_START',
  RECEIVE_HMS_AUDIENCE_INSIGHTS_START: 'RECEIVE_HMS_AUDIENCE_METRICS_START',
  REQUEST_SUMMARY_TRAFFIC_STATS: 'REQUEST_SUMMARY_TRAFFIC_STATS',
  RECEIVE_SUMMARY_TRAFFIC_STATS: 'RECEIVE_SUMMARY_TRAFFIC_STATS',
};
